module.exports = __webpack_public_path__ + "img/download_import.c8824d99.svg";